export default __webpack_public_path__ + "static/media/photo--lg--ish-1.71e2fa94.jpg";